import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/api'
import { useUserStore } from '@/stores'
import { swalError } from '@/utils'

export function useLogin() {
  const router = useRouter()

  const userStore = useUserStore()

  /** ログインフォーム */
  const loginForm = reactive(new LoginForm())

  /** 有料会員ログイン */
  function login() {
    api.user
      .login(loginForm)
      .then(async _user => {
        await userStore.storeHash(_user.userHash)
        router.push('mypage')
      })
      .catch(async err => {
        swalError.fire({ text: err })
        // 保存されているユーザーデータもリセットする
        await userStore.clear()
      })
  }

  return { loginForm, login }
}

export class LoginForm {
  loginId: string
  loginPw: string
  constructor() {
    this.loginId = ''
    this.loginPw = ''
  }
  clear() {
    this.loginId = ''
    this.loginPw = ''
  }
}
